import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8d844ca4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"padding":"16px","height":"100%","display":"flex","flex-direction":"column","justify-content":"space-between","box-sizing":"border-box"}
}
const _hoisted_2 = { class: "cm-ui-ml10 cm-ui-mt10" }
const _hoisted_3 = { class: "cm-ui-ml10 cm-ui-mt10 cm-ui-mb10" }
const _hoisted_4 = {
  class: "cm-align-center",
  style: {"flex":"1"}
}
const _hoisted_5 = {
  class: "ip-strategy-remote-ip-slot",
  style: {"width":"100%","box-sizing":"border-box"}
}
const _hoisted_6 = { class: "regular-tasks-block" }
const _hoisted_7 = { class: "cm-align-center" }

import { formLabelStyle } from '@/components/cmForm/globalOpt'
import CmForm from '@/components/cmForm/index.vue'
import { FormActionType, FormSize, FormType } from '@/components/cmForm/types'
import { PermissionFe } from '@/services/service-permission.service'
import { formatMapToOptions } from '@/utils/tool'
import PolicyBindScope from '@/views/dashboard/policy/_components/policy-bind-scope.vue'
import { policyBindScopeFormRules } from '@/views/dashboard/policy/_components/policy-bind-scope-form-rule'
import { PolicySettingType, PolicyType, } from '@/views/dashboard/_enum/policy-type'
import {
  PolicyCommonService,
  SaveSettingsReq,
  StrategyListDataCommon,
  errorDetailToFailedEntries,
  normalizeTemplateImportData,
} from '@/views/dashboard/policy/policy-common.service'
import { ExcelImportDialog } from '@/components/excel-import-dialog'
import type {
  ExcelImportDialogCopy,
  ExcelImportDialogMessages,
  ExcelImportFileResult,
} from '@/components/excel-import-dialog'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
import { computed, nextTick, PropType, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import TaskTimeEdit from '@/views/dashboard/_components/task-time/task-time-edit.vue'
import { DefaultEndTaskTime } from '@/views/dashboard/_components/task-time/task-time.service'
import { team, user } from '@/common/basis/root-injector'
import { resolveHttpErrorMessage } from '@/common/error/error-code'
import {
  ActionState,
  DirectionState,
  frequencyState,
  localPortLabel,
  PortTypeState,
  ProtocolState,
} from '../types'
import {
  getActionStateLabelMap,
  getDirectionStateDictLongMap,
  getFrequencyStateLabelMap,
  getPortTypeStateLabelMap,
  getProtocolStateLabelMap,
} from '../ip-address-blocking-labels'


export default /*#__PURE__*/_defineComponent({
  __name: 'strategy-setting',
  props: {
  api: {
    type: Object as PropType<{
      saveOrUpdateApi: (data: SaveSettingsReq) => Promise<void>;
      getApi: ({ id, type }: { id: string; type: PolicySettingType }) => Promise<void>;
    }>,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  hasPermission: {
    type: Boolean,
    default: false,
  },
  fromGroupId: {
    type: Number,
  },
  triggerTimeCallback: {
    type: Function as PropType<(item: StrategyListDataCommon) => void>,
    default: undefined,
  },
},
  emits: ['update:modelValue', 'refresh'],
  setup(__props, { emit: __emit }) {

const { t, locale } = useI18n()

const policyInjector = useReflectiveInjector([PolicyCommonService])
const policyCommonService = policyInjector.get(PolicyCommonService)
const ipExcelImportVisible = ref(false)

const ipImportDialogCopy = computed<ExcelImportDialogCopy>(() => {
  void locale.value
  const p = 'ipAddressBlocking.ipBatchImport'
  return {
    step1: t(`${p}.step1`),
    step2: t(`${p}.step2`),
    downloadTemplate: t(`${p}.downloadTemplate`),
    downloadTip: t(`${p}.downloadTip`),
    uploadTip: t(`${p}.uploadTip`),
    formatTip: t(`${p}.formatTip`),
    dragTip: t(`${p}.dragTip`),
    clickUpload: t(`${p}.clickUpload`),
    reupload: t(`${p}.reupload`),
    cancel: t(`${p}.cancel`),
    confirmImport: t(`${p}.confirmImport`),
    importFailTitle: t(`${p}.importFailTitle`),
    uploadFormatWarn: t(`${p}.uploadFormatWarn`),
    invalidFileFormat: t(`${p}.invalidFileFormat`),
    selectFileFirst: t(`${p}.selectFileFirst`),
  }
})

const ipImportDialogMessages = computed<ExcelImportDialogMessages>(() => {
  void locale.value
  const p = 'ipAddressBlocking.ipBatchImport'
  return {
    downloadSuccess: t(`${p}.templateDownloadSuccess`),
    downloadFail: t(`${p}.templateDownloadFail`),
    importSuccess: t(`${p}.importSuccess`),
  }
})

function splitRemoteIpInput(raw: string): string[] {
  return String(raw ?? '')
    .split(/[,，;；\n\r]+/)
    .map((s) => s.trim())
    .filter(Boolean)
}

function mergeImportedRemoteIps(ips: string[]) {
  const merged = new Set(splitRemoteIpInput(String(form.value.remote_ip ?? '')))
  for (const ip of ips) {
    const x = String(ip).trim()
    if (x) merged.add(x)
  }
  form.value.remote_ip = [...merged].join(',')
}

async function onIpImportDownload() {
  await policyCommonService.getStrategyTemplateDownload({ template_type: 'ip' })
}

async function onIpImportFile(file: File): Promise<ExcelImportFileResult> {
  const fd = new FormData()
  fd.append('file', file)
  fd.append('template_type', 'Ip')
  fd.append('team_id', String(team.getCurrentTeam().team_id))
  fd.append('uid', user.getUserInfo().uid)
  fd.append('token', user.getUserInfo().token)
  const result = (await policyCommonService.getStrategyImportParse(fd)) as {
    data?: unknown
    error_detail?: unknown
    resp_common?: { ret?: number; msg?: string }
  }
  const rc = result?.resp_common
  const ok = !rc || rc.ret === 0 || rc.msg === 'ok'
  if (rc && !ok) {
    const ret = rc.ret != null ? Number(rc.ret) : NaN
    const resolved = Number.isFinite(ret) ? resolveHttpErrorMessage(ret, rc.msg) : ''
    const err: any = new Error(
      resolved || rc.msg || t('ipAddressBlocking.ipBatchImport.importFail'),
    )
    err.resp_common = rc
    throw err
  }
  const list = normalizeTemplateImportData(result.data)
  const failedEntries: Record<string, string | number> = errorDetailToFailedEntries(result.error_detail)

  if (!list.length) {
    if (Object.keys(failedEntries).length) {
      return { failedEntries }
    }
    ElMessage.info(t('ipAddressBlocking.ipBatchImport.noIpParsed'))
    return { failedEntries: {}, closeDialog: false, suppressSuccessToast: true }
  }
  mergeImportedRemoteIps(list)
  return { failedEntries }
}

const props = __props



// 表单的禁用/启用
const disabled = ref(!props.hasPermission)
// 表单实例对象
const formRef = ref()
const globalOpt = ref({ required: true })
// 表单的提交loading
const loading = ref(false)
const loadingPage = ref(false)
const strategyOver = ref({ type: PolicyType.ip_address_blocking, current: '' })
// 默认表单
const defaultFormData = {
  direction: DirectionState.bidirectional, name: '', port_type: PortTypeState.custom_port, action: ActionState.just_record, protocol: ProtocolState.arbitrary_agreement, local_port: '', remote_ip: '', remote_port: '', frequency: frequencyState.day, regular_tasks: [...DefaultEndTaskTime], group_ids: [], bind_mode: 0, device_ids: [] as string[],
}
// 表单数据
const form: any = ref(defaultFormData)
// 表单项配置（使用 computed 以支持多语言切换）
const formColumns = computed(() => {
  const _localeDep = locale.value
  const isCustomPort = form.value.port_type === PortTypeState.custom_port
  return {
    name: { label: t('ipAddressBlocking.policyName'), inputOpt: { maxlength: 50 } },
    action: { label: t('ipAddressBlocking.executeAction'), type: FormType.Radio, dictData: formatMapToOptions(getActionStateLabelMap(t), true) },
    direction: { label: t('ipAddressBlocking.interceptDirection'), colOpt: { span: 24 }, type: FormType.Radio, dictData: formatMapToOptions(getDirectionStateDictLongMap(t), true) },
    protocol: { label: t('ipAddressBlocking.protocol'), type: FormType.Radio, dictData: formatMapToOptions(getProtocolStateLabelMap(t), true) },
    frequency: {
      label: t('ipAddressBlocking.executeFreq'),
      required: false,
      type: FormType.Radio,
      dictData: formatMapToOptions(getFrequencyStateLabelMap(t), true),
      events: {
        change() {
          form.value.regular_tasks = [...DefaultEndTaskTime]
        }
      }
    },
    regular_tasks: { label: t('ipAddressBlocking.regularTasks'), required: false, slot: true },
    port_type: { label: t('ipAddressBlocking.localPortType'), required: false, type: FormType.Radio, dictData: formatMapToOptions(getPortTypeStateLabelMap(t), true) },
    local_port: {
      label: t('ipAddressBlocking.localPort'),
      modelModifiers: { trim: true },
      inputType: 'textarea',
      required: false,
      placeholder: isCustomPort ? t('ipAddressBlocking.localPortPlaceholder') : t('ipAddressBlocking.selectCommonPortPlaceholder'),
      type: isCustomPort ? undefined : FormType.Select,
      selectOpt: { multiple: true, clearable: true, filterable: true },
      tipContent: t('ipAddressBlocking.localPortTip'),
      dictData: localPortLabel
    },
    remote_ip: {
      label: t('ipAddressBlocking.remoteIp'),
      slot: true,
      inputType: 'textarea',
      tipContent: t('ipAddressBlocking.remoteIpPlaceholder'),
      placeholder: t('ipAddressBlocking.remoteIpPlaceholder'),
    },
    remote_port: {
      label: t('ipAddressBlocking.remotePort'),
      modelModifiers: { trim: true },
      inputType: 'textarea',
      required: false,
      tipContent: t('ipAddressBlocking.remotePortPlaceholder'),
      placeholder: t('ipAddressBlocking.remotePortPlaceholder')
    },
    group_ids: {
      label: t('policyBindScope.applyMode'),
      prop: 'group_ids',
      required: false,
      formItemOpt: { required: false },
      rules: policyBindScopeFormRules(() => form.value, t),
      labelSlot: true,
      slot: true,
      colOpt: { span: 24 },
    },
  }
})
const emits = __emit
const visible = computed({
  get: () => props.modelValue,
  set: (value) => {
    emits('update:modelValue', value)
  },
})
const cancel = () => {
  visible.value = false
  handleReset();
  window.location.search && (window.location.search = '')
}
const validateTree = () => {
  formRef.value?.ruleFormRef?.validateField?.('group_ids')
}
const route = useRoute()

// 表单重置
const handleReset = async () => {
  form.value = { ...defaultFormData }
}
// 表单数据提交
const handleSubmit = async () => {
  const valid = await formRef.value.handleSubmit()
  if (!valid) return
  const bm = form.value.bind_mode ?? 0
  loadingPage.value = true
  loading.value = disabled.value = true
  const formCopy = { ...form.value }
  delete formCopy.name
  delete formCopy.group_ids
  if (!Array.isArray(formCopy.local_port)) { formCopy.local_port = formCopy.local_port.split(',') }
  if (!Array.isArray(formCopy.remote_ip)) { formCopy.remote_ip = splitRemoteIpInput(String(formCopy.remote_ip ?? '')) }
  if (!Array.isArray(formCopy.remote_port)) { formCopy.remote_port = formCopy.remote_port.split(',') }
  const strategy = { ...formCopy }
  const formData: SaveSettingsReq = {
    name: form.value.name,
    group_ids: form.value.group_ids,
    device_ids: form.value.device_ids || [],
    bind_mode: bm,
    id: form.value.id,
    type: PolicySettingType.ip_address_blocking,
    strategy_type: PolicyType.ip_address_blocking,
    strategy: JSON.stringify(strategy),
  }
  const result: any = await props.api.saveOrUpdateApi(formData).finally(() => loading.value = loadingPage.value = disabled.value = false)
  const ok = result?.resp_common?.msg === 'ok'
  ElMessage({
    type: ok ? 'success' : 'error',
    message: ok ? t('ipAddressBlocking.operateSuccess') : t('ipAddressBlocking.operateFailed'),
  })
  if (ok) {
    emits('refresh')
    visible.value = false
    form.value.id = undefined
  }
}
watch(
  () => props.modelValue,
  async (nv, ov) => {
    handleReset()
    if (nv && props.id) {
      loadingPage.value = true
      strategyOver.value.current = props.id
      const result: any = await props.api.getApi({
        id: props.id,
        type: PolicySettingType.ip_address_blocking,
      })
      form.value = {
        ...form.value,
        ...result,
        ...result.strategy,
        group_ids: result.strategy_group_ids,
        bind_mode: result.bind_mode ?? 0,
        device_ids: result.device_ids ?? [],
        id: props.id,
      }
      loadingPage.value = false
    }
  },
  {
    immediate: true,
  },
)

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (visible.value)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CmForm, {
          formSize: _unref(FormSize).Small,
          ref_key: "formRef",
          ref: formRef,
          style: {"flex":"1","overflow-y":"auto","overflow-x":"hidden"},
          modelValue: form.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form).value = $event)),
          formType: _unref(FormActionType).Other,
          "onUpdate:formType": _cache[5] || (_cache[5] = ($event: any) => ((_unref(FormActionType).Other) = $event)),
          disabled: disabled.value,
          "onUpdate:disabled": _cache[6] || (_cache[6] = ($event: any) => ((disabled).value = $event)),
          formColumns: formColumns.value,
          formOpt: { 'label-width': 'auto', labelPosition: 'left' },
          opeRowOpt: { justify: 'start', style: { marginTop: '20px' } },
          onReset: _cache[7] || (_cache[7] = () => (visible.value = false)),
          rowOpt: { style: { display: 'grid' }, class: 'gap-20' },
          globalOpt: globalOpt.value
        }, {
          group_ids: _withCtx(() => [
            _createVNode(PolicyBindScope, {
              "bind-mode": form.value.bind_mode ?? 0,
              "group-ids": form.value.group_ids || [],
              "device-ids": form.value.device_ids || [],
              "preset-group-id": form.value.id ? undefined : __props.fromGroupId,
              "permission-key": _unref(PermissionFe).internet_ip_limit,
              "strategy-over": strategyOver.value,
              disabled: disabled.value,
              "onUpdate:bindMode": _cache[0] || (_cache[0] = 
            (v) => {
              form.value.bind_mode = v
              nextTick(() => validateTree())
            }
          ),
              "onUpdate:groupIds": _cache[1] || (_cache[1] = ($event: any) => (form.value.group_ids = $event)),
              "onUpdate:deviceIds": _cache[2] || (_cache[2] = 
            (v) => {
              form.value.device_ids = v
              nextTick(() => validateTree())
            }
          ),
              onGroupUpdate: validateTree
            }, {
              "group-tip": _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('ipAddressBlocking.policyGroupTipTitle')), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('ipAddressBlocking.policyGroupTip')), 1)
              ]),
              _: 1
            }, 8, ["bind-mode", "group-ids", "device-ids", "preset-group-id", "permission-key", "strategy-over", "disabled"])
          ]),
          "group_ids-label": _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                style: _normalizeStyle(_unref(formLabelStyle))
              }, _toDisplayString(_ctx.$t('policyBindScope.applyMode')), 5)
            ])
          ]),
          remote_ip: _withCtx(({ prop, formItem }) => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_input, {
                type: "textarea",
                modelValue: form.value[prop],
                "onUpdate:modelValue": ($event: any) => ((form.value[prop]) = $event),
                placeholder: formItem.placeholder,
                disabled: disabled.value
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"]),
              _createVNode(_component_el_button, {
                type: "text",
                size: "small",
                disabled: disabled.value,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (ipExcelImportVisible.value = true)),
                icon: "el-icon-upload2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('ipAddressBlocking.batchImport')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          regular_tasks: _withCtx(({ prop }) => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(TaskTimeEdit, {
                modelValue: form.value[prop],
                "onUpdate:modelValue": ($event: any) => ((form.value[prop]) = $event),
                "main-switch": true,
                "mix-type": form.value.frequency,
                "default-end-min": 23 * 60 + 50
              }, null, 8, ["modelValue", "onUpdate:modelValue", "mix-type"])
            ])
          ]),
          _: 1
        }, 8, ["formSize", "modelValue", "formType", "disabled", "formColumns", "globalOpt"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: cancel,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (handleSubmit())),
            loading: loading.value,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _createVNode(_unref(ExcelImportDialog), {
          modelValue: ipExcelImportVisible.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ipExcelImportVisible).value = $event)),
          title: _unref(t)('ipAddressBlocking.ipBatchImport.title'),
          copy: ipImportDialogCopy.value,
          messages: ipImportDialogMessages.value,
          "on-download-template": onIpImportDownload,
          "on-import-file": onIpImportFile
        }, null, 8, ["modelValue", "title", "copy", "messages"])
      ])), [
        [_directive_loading, loadingPage.value]
      ])
    : _createCommentVNode("", true)
}
}

})